import $ from "jquery";
import showElements from './onshow-elements';

export default function loadElements(page, maxPages, baseUrl, selector) {
    if (page >= maxPages) {
        return;
    }
    let hasLoaded = false;
    const callback = (entries) => {
        entries.forEach(entry => {
            if (!hasLoaded && (entry.isIntersecting || entry.boundingClientRect.top < 0)) {
                hasLoaded = true;
                page += 1;
                $('<div>').load(baseUrl + '?page=' + page + ' ' + selector + ' > *', function() {
                    $(selector).append($(this).children());
                    showElements('.animate');
                    loadElements(page, maxPages, baseUrl, selector);
                });
            }
        });
    };
    const observer = new IntersectionObserver(callback);
    observer.observe(document.querySelector(selector + ' >*:nth-last-child(2)'));
}